<template>
  <ModelEditFormPriceAgreement
    class="model-edit-form-known-business-entity-rental-dispense-item"
    v-model="priceAgreement"
    :is-retrieving="isRetrieving"
    :project="project"
    variant="businessEntity"
    @input="wasChanged = true"
  />
</template>

<script setup lang="ts">
import ModelEditFormPriceAgreement from "@/components/model_edit_form/ModelEditFormPriceAgreement.vue"
import { Project } from "@/models/project.model"
import { useModelEditFormPriceAgreementManager } from "@/composables/administration/model-edit-form-project-price-agreement-manager"
import { inject } from "vue"
import type { RentalDispenseItem } from "@/models/rental-dispense-item.model"
import { useKnownBusinessEntitiesRentalDispenseItemsStore } from "@/store/known-business-entities-rental-dispense-items.store.ts"
import { KnownBusinessEntityRentalDispenseItem } from "@/models/known-business-entity-rental-dispense-item.model.ts"

const props = defineProps<{
  project: Project
  rentalDispenseItem: RentalDispenseItem
}>()

const { priceAgreement, savePriceAgreement, isRetrieving, wasChanged } =
  useModelEditFormPriceAgreementManager<RentalDispenseItem, KnownBusinessEntityRentalDispenseItem>(
    props.project,
    props.rentalDispenseItem,
    useKnownBusinessEntitiesRentalDispenseItemsStore(),
    inject("knownBusinessEntityRentalDispenseItemController")!,
    KnownBusinessEntityRentalDispenseItem
  )

defineExpose({ savePriceAgreement })
</script>

<style scoped></style>
